// 打印入口：费用报销单（个人，A4 横向）
import { printHtml } from "../htmlPrint";
import { buildExpenseHtml } from "./printTemplates";
import { expense } from "../printConfig";

export default function(Info) {
  printHtml(buildExpenseHtml(Info, false), {
    ...expense,
    title: "费用报销单",
  });
}
